import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
export function ProductOption() {
    return /*#__PURE__*/ _jsx("div", {
        children: "aaaa"
    });
}
